import React from 'react'
import className from 'classnames/bind'

import style from './MyhouseCommunityRegistGuide.module.scss'

const cx = className.bind(style)

type Props = {
  percentage: number
}

const MyhouseCommunityRegistGuide: React.FC<Props> = ({ percentage }: Props) => {
  return (
    <>
      <div className={cx('article')}>
        <div className={cx('inner')}>
          <p className={cx('text')}>게시글 등록 중 입니다.</p>
          <div className={cx('loading')}>
            {/* todo: width 0 ~ 100%까지 변경 */}
            <div className={cx('bar')} style={{ width: `${percentage || 0}%` }} />
          </div>
        </div>
      </div>
    </>
  )
}

export default MyhouseCommunityRegistGuide
